import React from "react";
import "./App.css";
import "./index.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_us from "./components/about_us/About_us";
import Vendors from "./components/vendors/Vendors";
import Experts from "./components/experts/Experts";
import Login from "./components/header/login/Login";
import Profile from "./components/header/profile/Profile";
import Wallet from "./components/header/wallet/Wallet";
import History from "./components/header/history/history-inner-page/History_Inner_Page";
import Logout_Modal from "./components/header/logout/Logout_Modal";
import Privacy_Policy from "./components/footer/privacy-policy/Privacy_Policy";
import Terms_Conditions from "./components/footer/terms_conditions/Terms_Conditions";
import Vendor_Login_Details from "./components/header/login/vendor-login-details/Vendor_Login_Details";
import Expert_Login_Details from "./components/header/login/expert-login-details/Expert_Login_Details";
import Contact_Us from "./components/contact-us/Contact_Us";
function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/vendors" element={<Vendors />} />
      </Routes>

      <Routes>
      
      </Routes>

      <Routes>
        <Route path="/experts" element={<Experts />} />
      </Routes>

      <Routes>
        <Route path="/aboutus" element={<About_us />} />
      </Routes>

      <Routes>
        <Route path="/contactus" element={<Contact_Us />} />
      </Routes>

      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>

      <Routes>
        <Route path="/profile" element={<Profile />} />
      </Routes>

      <Routes>
        <Route path="/wallet" element={<Wallet />} />
      </Routes>

      <Routes>
        <Route path="/history" element={<History />} />
      </Routes>

      <Routes>
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
      </Routes>

      <Routes>
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
      </Routes>

      <Routes>
        <Route
          path="/vendor-login-details"
          element={<Vendor_Login_Details />}
        />
      </Routes>

      <Routes>
        <Route
          path="/expert-login-details"
          element={<Expert_Login_Details />}
        />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
